module.exports = __webpack_public_path__ + "img/timeline_logo.91d78aae.jpg";